import cn from '../../../utils/cn';
import styles from './MobileCollapsible.module.css';

/**
 * Collapses its children on small viewports when `isOpen` is false; always expanded from `--breakpoint-mobile` + 1px up.
 * Pair with `useMobileReveal` and a control that calls `onToggleClick`.
 * @param {object} props
 * @param {boolean} props.isOpen
 * @param {React.ReactNode} props.children
 * @param {string} [props.className]
 * @param {string} [props.id] - e.g. for `aria-controls` on the mobile toggle
 * @returns {JSX.Element}
 */
function MobileCollapsible({
  isOpen,
  children,
  className = '',
  id,
}) {
  return (
    <div
      id={id}
      className={cn([styles.root, className])}
      data-open={isOpen}
    >
      <div className={styles.inner}>
        {children}
      </div>
    </div>
  );
}

export default MobileCollapsible;
